function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12.46,0A12.46,12.46,0,1,0,24.91,12.46,12.46,12.46,0,0,0,12.46,0Zm0,24.16A11.65,11.65,0,0,1,4.5,21l4.67-4.67-.53-.52L4,20.51A11.7,11.7,0,0,1,20.51,4L15.38,9.09l.53.53L21,4.5a11.7,11.7,0,0,1-8.57,19.66Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M15.7,11l-.16-.07a2.79,2.79,0,0,1-1.48-1.75,19.35,19.35,0,0,0-1-2.48A5.15,5.15,0,0,0,9.84,3.81a3.57,3.57,0,0,0-3,.39C4.64,5.7,4.8,8.53,6.08,10.44a13,13,0,0,0,2.24,2.08l.07.06a2.71,2.71,0,0,1,1.06,2,7.3,7.3,0,0,0,1.28,3.71,7.12,7.12,0,0,0,3.5,2.79,4.8,4.8,0,0,0,1.63.29A3.86,3.86,0,0,0,18,20.75a4.21,4.21,0,0,0,1.76-3.39,7.17,7.17,0,0,0-1.28-4.29A6,6,0,0,0,15.7,11ZM19,17.32a3.49,3.49,0,0,1-1.42,2.81h0a3.51,3.51,0,0,1-3.14.27,6.42,6.42,0,0,1-3.12-2.51,6.64,6.64,0,0,1-1.15-3.32A3.52,3.52,0,0,0,8.85,12l-.07-.05A12.67,12.67,0,0,1,6.7,10c-1.46-2.17-.81-4.26.59-5.2A2.52,2.52,0,0,1,8.74,4.4a3.16,3.16,0,0,1,.9.13A4.48,4.48,0,0,1,12.42,7a18.86,18.86,0,0,1,.93,2.37,3.47,3.47,0,0,0,1.88,2.21l.16.08a5.26,5.26,0,0,1,2.49,1.82A6.33,6.33,0,0,1,19,17.32Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M15.44,19.26a1.08,1.08,0,0,1-.65-.37.37.37,0,0,0-.52.54,1.77,1.77,0,0,0,1,.55h.09a.37.37,0,0,0,.09-.73Z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M11.65,14.51l0-.11a.38.38,0,0,0-.74.13l0,.11a6.79,6.79,0,0,0,2,4,.36.36,0,0,0,.26.11.37.37,0,0,0,.27-.12.37.37,0,0,0,0-.52A6.1,6.1,0,0,1,11.65,14.51Z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M9.28,5.63a.41.41,0,0,0,.14.8A.4.4,0,0,0,9.75,6,.41.41,0,0,0,9.28,5.63Z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M10.36,6.47a.41.41,0,1,0,.47.34A.41.41,0,0,0,10.36,6.47Z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M8.91,7a.41.41,0,0,0-.33.47.41.41,0,1,0,.8-.14A.41.41,0,0,0,8.91,7Z"
});

function SvgNutFree(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 20,
    width: 20,
    fill: "currentColor",
    stroke: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24.91 24.91",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNutFree);
export default __webpack_public_path__ + "static/media/NutFree.968b16e5.svg";
export { ForwardRef as ReactComponent };